export default function PowerBi() {
  return (
    <div className="col-md-12 col-sm-12">
        <h2>Pwer BI here now</h2>
      </div>
  );
}
